<app-template-form [template]="template$ | async" [fields]="fields$ | async" [loading]="loading$ | async"
    [fieldsTemplate]="fieldsTemplate$ | async" (templateUpdated$)="updateTemplate($event)"
    (emailFieldsUpdated$)="updateEmailFields($event)">
</app-template-form>